import {
  SearchPageSortOptionAllPropertyStatusesValues,
  SearchPageSortOptionForRentValues,
  SearchPageSortOptionForSaleValues,
  SearchPageSortOptionOffMarketValues,
  SearchPageSortOptionSoldValues,
  SearchPropertyStatus,
} from '../types';

const searchAPIWhitelistSortOptions: { [key: string]: string[] } = {
  FOR_SALE: SearchPageSortOptionForSaleValues,
  FOR_RENT: SearchPageSortOptionForRentValues,
  SOLD: SearchPageSortOptionSoldValues.filter((value) => value !== 'RELEVANCE'),
  OFF_MARKET: SearchPageSortOptionOffMarketValues,
  ALL: SearchPageSortOptionAllPropertyStatusesValues,
};

export const isValidSortOption = (
  propertyStatus: SearchPropertyStatus,
  sortOptionValue: string,
): boolean => {
  if (!sortOptionValue) return false;
  const whiteList = searchAPIWhitelistSortOptions[propertyStatus];

  return whiteList?.includes(sortOptionValue);
};
